import * as Yup from 'yup';
import { matchPath } from 'react-router-dom';

const routes = [
  { path: '/dashboard', title: 'Dashboard' },
  { path: '/customers', title: 'Customers' },
  { path: '/meals/create/new', title: 'Create New Meal', exact: true },
  { path: '/meals/edit', title: 'Edit Meal' },
  { path: '/meals/:id', title: 'Meal Details' },
  { path: '/meals', title: 'Meals', exact: true },
  { path: '/recipe-collection', title: 'Recipe Collection', exact: true },
  { path: '/recipe-groups', title: 'Recipe Groups', exact: true },
  { path: '/ingredrients-list', title: 'Ingredients List', exact: true },
  { path: '/meal/tags', title: 'Meal Tags', exact: true },
  { path: '/product-groups', title: 'Product Groups', exact: true },
  { path: '/facts', title: 'LU Facts', exact: true },
  { path: '/blogs', title: 'Blogs', exact: true },
  { path: '/settings', title: 'Settings', exact: true }
];

export const validateRecipeCollection = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  meal_plan: Yup.string().required('Meal plan is required'),
  servings: Yup.number()
    .typeError('Servings must be a number')
    .positive('Servings must be greater than zero')
    .integer('Servings must be a whole number')
    .required('Servings are required'),
  meal_types: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Meal type value is required'),
        label: Yup.string().required('Meal type label is required')
      })
    )
    .min(1, 'At least one meal type is required'),

  recipes: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Recipe value is required'),
        label: Yup.string().required('Recipe label is required')
      })
    )
    .min(1, 'At least one recipe is required'),
  price: Yup.object().shape({
    currency: Yup.string().required('Currency is required'),
    value: Yup.number()
      .typeError('Price must be a number')
      .positive('Price must be greater than zero')
      .required('Price is required')
  })
});

export const getRandomImage = (recipes) => {
  if (!recipes.length) return null; // Handle empty array case
  const randomIndex = Math.floor(Math.random() * recipes.length);
  return recipes[randomIndex].image;
};

const CATEGORY_COLOR_MAP = {
  'dietary preference': {
    bg: '#FFE9F2', // pink
    text: '#1F2937'
  },
  'nutritional focus': {
    bg: '#EBECFF', // lavender
    text: '#1F2937'
  },
  'meal type': {
    bg: '#E6FFEA',
    text: '#1F2937'
  },
  'cusine type': {
    bg: '#FFF1F1',
    text: '#1F2937'
  },
  'cooking method': {
    bg: '#FCE1FF',
    text: '#1F2937'
  },
  'special occassion': {
    bg: '#E3FFF7',
    text: '#1F2937'
  },
  ingredient: {
    bg: '#EEFFF0',
    text: '#1F2937'
  }
};

const DEFAULT_CATEGORY_COLOR = {
  bg: '#F3F4F6', // neutral gray
  text: '#1F2937'
};

const normalizeCategory = (category) => category.trim().toLowerCase();

export const getCategoryColor = (category) => {
  const key = normalizeCategory(category);
  return CATEGORY_COLOR_MAP[key] ?? DEFAULT_CATEGORY_COLOR;
};

export const getCrumbs = (path) => {
  const matched = routes.find((route) =>
    matchPath(path, { path: route.path, exact: route.exact ?? false })
  );

  return matched ? { title: matched.title } : null;
};
